import { render, staticRenderFns } from "./AlbumImage.vue?vue&type=template&id=c629ad20&scoped=true&lang=pug&"
import script from "./AlbumImage.vue?vue&type=script&lang=js&"
export * from "./AlbumImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c629ad20",
  null
  
)

export default component.exports